<script>
import { mapState, mapActions } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import { debounce } from 'vue-debounce'
import PaginationCustom from '@/components/table/Pagination.vue'
import Permohonan from '@/components/mppd/Permohonan.vue'

export default {
   name: 'Mppd',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      SweetModal,
      VuePdfApp,
      Permohonan,
   },
   data() {
      return {
         pdf: '',
         loadingPdf: false,
         loading: true,
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         columns: [
            {
               label: 'Register',
               field: 'register',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Pemohon',
               field: 'nama_pemohon',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'SIP',
               field: 'sip',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Fasyankes',
               field: 'fasyankes',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center align-middle',
            },
         ],
      }
   },
   computed: {
      ...mapState({
         myData: state => state.Mppd.items,
         myCount: state => state.Mppd.countAll,
      }),
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'Mppd/getData',
         getDataDetail: 'Mppd/getDetail',
         cetakIzin: 'Mppd/cetakIzin',
      }),
      onPermohonanDetail(id) {
         this.getDataDetail(id).then(() => {
            this.$bvModal.show('modal-proses')
         }, () => {

         })
      },
      onCetakIzin(id) {
         this.loadingPdf = true
         this.cetakIzin(id).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onFilter() {
         this.serverParams.page = 1
         this.loadItems()
      },

      // VUE GOOD TABLE
      loadItems() {
         this.loading = true
         this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
   },
}
</script>

<template>
   <div>
      <b-card-code title="Data Permohonan MPP Digital">
         <!-- search input -->
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search..."
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button variant="outline-secondary" size="sm" @click="onFilter()">
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="loadItems()">
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown variant="outline-secondary" right text="Menu" size="sm">
                        <b-dropdown-item @click="onFilter()">
                           Filter
                        </b-dropdown-item>
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>
         </b-row>

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: Name -->
               <span v-if="props.column.field == 'register'">
                  <b>{{ (props.row.register) }}</b>
                  <br>
                  <small>Tanggal : {{ props.row.tgl_reg | moment("DD-MM-YYYY") }}</small>
               </span>

               <span v-if="props.column.field == 'nama_pemohon'">
                  <b>{{ props.row.nama }}</b>
                  <br>
                  <small>NIK : {{ props.row.nik }}</small>
                  <br>
                  <small>JK : {{ props.row.jk }}</small>
               </span>

               <span v-if="props.column.field == 'sip'">
                  <b>{{ props.row.jenis_izin }}</b>
                  <br>
                  <small>{{ props.row.jenis_permohonan }}</small>
                  <br>
                  <small>Periode : {{ props.row.tgl_sip_awal | moment("DD-MM-YYYY") }} s/d {{ props.row.tgl_sip_akhir | moment("DD-MM-YYYY") }}</small>
                  <br>
                  <small>Terbit : {{ props.row.tgl_terbit | moment("DD-MM-YYYY") }}</small>
                  <br>
                  <small>Nomor : {{ props.row.no_sip }}</small>
               </span>

               <span v-if="props.column.field == 'fasyankes'">
                  <b>{{ props.row.nama_fayankes }}</b>
                  <br>
                  <small>Kategori : {{ props.row.kategori_fayankes }}</small>
                  <br>
                  <small>Alamat : {{ props.row.alamat_fayankes }}</small>
               </span>

               <span v-if="props.column.field == 'action'">
                  <b-button size="sm" block variant="outline-dark" @click="onPermohonanDetail(props.row.id)">
                     <feather-icon icon="ListIcon" class="mr-50" />
                     <small>Detail</small>
                  </b-button>
                  <b-button
                     v-if="props.row.s3_path"
                     size="sm"
                     block
                     variant="primary"
                     @click="onCetakIzin(props.row.id)"
                  >
                     <feather-icon icon="FileTextIcon" class="mr-50" />
                     <small>Cetak</small>
                  </b-button>
               </span>
               <!-- Column: Common -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <b-modal
         id="modal-proses"
         scrollable
         size="xl"
         centered
         hide-footer
         title="Detail Permohonan"
      >
         <div style="height: 70vh;">
            <Permohonan />
         </div>
      </b-modal>

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <!-- <pdf :src="pdf" /> -->
         <div style="height: 70vh;">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless>tr>td {
   border: none;
   padding: 0em;
}

.borderless>tr>td {
   border: none;
   padding: 0em;
}

table>tbody>tr>td>span>hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}

.nowrap {
   white-space: nowrap;
}
</style>

<style>
.hidden_header {
   display: none;
}
</style>
